<template>
    <InformationPage
        title="Terms and Conditions"
        description="Read the terms and conditions of using our service."
        :breadcrumb="[
            { icon: 'i-heroicons-home', label: 'Home', to: '/' },
            { label: 'Terms and Conditions' }
        ]"
    >
    <div class="prose ">
        <h2>1. Introduction</h2>
        <p>Welcome to our application. By using our service, you agree to comply with and be bound by the following terms and conditions.</p>

        <h2>2. User Responsibilities</h2>
        <p>Users are responsible for maintaining the confidentiality of their account information and for all activities that occur under their account.</p>

        <h2>3. Intellectual Property</h2>
        <p>All content provided on this application is the intellectual property of the company and is protected by applicable copyright laws.</p>

        <h2>4. Termination</h2>
        <p>We reserve the right to terminate or suspend access to our service immediately, without prior notice or liability, for any reason whatsoever.</p>

        <h2>5. Changes to Terms</h2>
        <p>We may update our terms and conditions from time to time. We will notify users of any changes by posting the new terms on this page.</p>

        <h2>6. Contact Us</h2>
        <p>If you have any questions about these terms, please contact us at support@example.com.</p>
    </div>
    <template #aside>
        <Timeline />
    </template>
</InformationPage>
</template>
<script setup lang="ts">
import InformationPage from '~/components/templates/InformationPage.vue';
import Timeline from '~/components/organisms/Timeline.vue';

definePageMeta({
    layout: 'information',
})
</script>